var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67 92H33.2V81.64c0-5.53-.54-11.15 3-16s7.55-7.49 13.61-7.56c4.81 0 8.21 1.75 11.68 5C67 68.29 66.89 75 66.71 81.75c-.07 2.65 0 5.32 0 8 0 .58.12 1.85.17 2.39h25.8c0-.66.1-1.8.1-2.25V42.04c0-2-2.13-3.2-3.64-4.29C76.47 28.57 50.26 9.33 49.81 9.06c-13 9.37-26.51 19-39.5 28.3a5.86 5.86 0 00-2.68 5.34c.08 15.27 0 30.53 0 45.8zm92.47-24v26.43c0 3.91-1.62 5.53-5.56 5.54H64.27c-3.89 0-5.4-1.51-5.41-5.36V75.7a9.15 9.15 0 00-14.07-7.93 8.94 8.94 0 00-4.21 8.11v18.45c0 4.15-1.46 5.64-5.6 5.65H5.55c-4.29 0-5.7-1.44-5.7-5.79V42.47a13.24 13.24 0 015.92-11.58c13.55-9.66 27-19.44 40.5-29.16 3.19-2.31 4.31-2.3 7.52 0 13.49 9.72 26.95 19.48 40.49 29.15a13.07 13.07 0 015.89 11.61c-.12 8.51-.03 17.02-.03 25.51z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.0ce158ba.svg";
export { ForwardRef as ReactComponent };